import React from "react";
import ReactDOM from "react-dom";
import Home from "./pages/Home";
import Error from "./pages/Error";
import Success from "./pages/success";
import { Switch, Route, HashRouter as Router } from "react-router-dom";
import {PrivateRoute,PrivateStateFullRoute} from  "common-utilities";
import * as serviceWorker from "./serviceWorker";
import "./index.scss";
ReactDOM.render(
  <React.StrictMode>
    <Router hashType={"slash"}>
      <Switch>
        <PrivateRoute 
          paramsName={['code']} 
          encodeTheUri={true} 
          path="/success" 
          exact
        >
          <PrivateStateFullRoute 
            keyName="code"
          >
            <Success />
          </PrivateStateFullRoute>
        </PrivateRoute>
        <Route 
          path="/error" 
          exact
        >
          <Error />
        </Route>
        <PrivateRoute 
          path="/" 
          paramsName={['code']} 
          encodeTheUri={true}
        >
          <Home />
        </PrivateRoute>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
